<mobi-ga-header
  [title]="entity().title"
  [secondaryTitle]="entity().secondaryTitle"
  [lead]="entity().lead"
  [moreText]="entity().moreText"
  [image]="entity().headerImage"
  [locations]="locations()"
  [openingHours]="openingHours()"
  [mainAgency]="mainAgency()"
  [contentLinks]="contentLinks()"
/>
<div class="page-content">
  @defer (hydrate on viewport) {
    <mobi-content-section
      [id]="
        'ga_services_content_link_paramenter_name'
          | texts: { context: 'frontend', default: 'dienste' }
          | anchorFormatter
      "
      width="lg"
      [content]="agencyInfo"
      [background]="true"
    >
      <ng-template #agencyInfo>
        @if (entity()?.gaWap) {
          <mobi-ga-agency-info-new
            [entity]="entity()"
            [mainAgency]="mainAgency()"
            [locations]="locations()"
            [locationItems]="locationItems()"
          />
        } @else {
          <mobi-ga-agency-info
            [entity]="entity()"
            [mainAgency]="mainAgency()"
            [locations]="locations()"
            [locationItems]="locationItems()"
          />
        }
      </ng-template>
    </mobi-content-section>
  }

  @defer (hydrate on viewport) {
    <mobi-content-section
      width="lg"
      [content]="personView"
      [id]="
        'ga_person_view_paramenter_name'
          | texts: { context: 'frontend', default: 'unser-team' }
          | anchorFormatter
      "
    >
      <ng-template #personView>
        <mobi-ga-person-view class="person-view" [entity]="entity()" />
      </ng-template>
    </mobi-content-section>
  }
  @defer (hydrate on viewport) {
    <mobi-ga-agency-maps
      [entity]="entity()"
      [locations]="locations()"
      [locationItems]="locationItems()"
    />
  }

  @defer (hydrate on viewport) {
    <mobi-content-section
      [id]="
        'ga_news_view_paramenter_name'
          | texts: { context: 'frontend', default: 'aus-der-region' }
          | anchorFormatter
      "
      width="lg"
      [content]="agencyNews"
    >
      <ng-template #agencyNews>
        <mobi-ga-agency-news [id]="entity()!.id" />
      </ng-template>
    </mobi-content-section>
  }
  @defer (hydrate on viewport) {
    <mobi-content-section
      [id]="
        'ga_recommended_view_paramenter_name'
          | texts: { context: 'frontend', default: 'empfohlene-inhalte' }
          | anchorFormatter
      "
      width="full"
      [content]="agencyPromotedContent"
      [background]="true"
    >
      <ng-template #agencyPromotedContent>
        <mobi-ga-agency-promoted-content [id]="entity()!.id" />
      </ng-template>
    </mobi-content-section>
  }
</div>
